import { render } from "./AssignIncentivesTableDetails.vue?vue&type=template&id=2da6c416"
import script from "./AssignIncentivesTableDetails.vue?vue&type=script&lang=js"
export * from "./AssignIncentivesTableDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__